/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "Hôm qua",
        "-2": "Hôm kia",
        "0": "Hôm nay",
        "1": "Ngày mai",
        "2": "Ngày kia",
        "future": {
          "other": "sau {0} ngày nữa"
        },
        "past": {
          "other": "{0} ngày trước"
        }
      },
      "day-narrow": {
        "-1": "hôm qua",
        "-2": "Hôm kia",
        "0": "hôm nay",
        "1": "ngày mai",
        "2": "Ngày kia",
        "future": {
          "other": "sau {0} ngày nữa"
        },
        "past": {
          "other": "{0} ngày trước"
        }
      },
      "day-short": {
        "-1": "hôm qua",
        "-2": "Hôm kia",
        "0": "hôm nay",
        "1": "ngày mai",
        "2": "Ngày kia",
        "future": {
          "other": "sau {0} ngày nữa"
        },
        "past": {
          "other": "{0} ngày trước"
        }
      },
      "hour": {
        "0": "giờ này",
        "future": {
          "other": "sau {0} giờ nữa"
        },
        "past": {
          "other": "{0} giờ trước"
        }
      },
      "hour-narrow": {
        "0": "giờ này",
        "future": {
          "other": "sau {0} giờ nữa"
        },
        "past": {
          "other": "{0} giờ trước"
        }
      },
      "hour-short": {
        "0": "giờ này",
        "future": {
          "other": "sau {0} giờ nữa"
        },
        "past": {
          "other": "{0} giờ trước"
        }
      },
      "minute": {
        "0": "phút này",
        "future": {
          "other": "sau {0} phút nữa"
        },
        "past": {
          "other": "{0} phút trước"
        }
      },
      "minute-narrow": {
        "0": "phút này",
        "future": {
          "other": "sau {0} phút nữa"
        },
        "past": {
          "other": "{0} phút trước"
        }
      },
      "minute-short": {
        "0": "phút này",
        "future": {
          "other": "sau {0} phút nữa"
        },
        "past": {
          "other": "{0} phút trước"
        }
      },
      "month": {
        "-1": "tháng trước",
        "0": "tháng này",
        "1": "tháng sau",
        "future": {
          "other": "sau {0} tháng nữa"
        },
        "past": {
          "other": "{0} tháng trước"
        }
      },
      "month-narrow": {
        "-1": "tháng trước",
        "0": "tháng này",
        "1": "tháng sau",
        "future": {
          "other": "sau {0} tháng nữa"
        },
        "past": {
          "other": "{0} tháng trước"
        }
      },
      "month-short": {
        "-1": "tháng trước",
        "0": "tháng này",
        "1": "tháng sau",
        "future": {
          "other": "sau {0} tháng nữa"
        },
        "past": {
          "other": "{0} tháng trước"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "quý trước",
        "0": "quý này",
        "1": "quý sau",
        "future": {
          "other": "sau {0} quý nữa"
        },
        "past": {
          "other": "{0} quý trước"
        }
      },
      "quarter-narrow": {
        "-1": "quý trước",
        "0": "quý này",
        "1": "quý sau",
        "future": {
          "other": "sau {0} quý nữa"
        },
        "past": {
          "other": "{0} quý trước"
        }
      },
      "quarter-short": {
        "-1": "quý trước",
        "0": "quý này",
        "1": "quý sau",
        "future": {
          "other": "sau {0} quý nữa"
        },
        "past": {
          "other": "{0} quý trước"
        }
      },
      "second": {
        "0": "bây giờ",
        "future": {
          "other": "sau {0} giây nữa"
        },
        "past": {
          "other": "{0} giây trước"
        }
      },
      "second-narrow": {
        "0": "bây giờ",
        "future": {
          "other": "sau {0} giây nữa"
        },
        "past": {
          "other": "{0} giây trước"
        }
      },
      "second-short": {
        "0": "bây giờ",
        "future": {
          "other": "sau {0} giây nữa"
        },
        "past": {
          "other": "{0} giây trước"
        }
      },
      "week": {
        "-1": "tuần trước",
        "0": "tuần này",
        "1": "tuần sau",
        "future": {
          "other": "sau {0} tuần nữa"
        },
        "past": {
          "other": "{0} tuần trước"
        }
      },
      "week-narrow": {
        "-1": "tuần trước",
        "0": "tuần này",
        "1": "tuần sau",
        "future": {
          "other": "sau {0} tuần nữa"
        },
        "past": {
          "other": "{0} tuần trước"
        }
      },
      "week-short": {
        "-1": "tuần trước",
        "0": "tuần này",
        "1": "tuần sau",
        "future": {
          "other": "sau {0} tuần nữa"
        },
        "past": {
          "other": "{0} tuần trước"
        }
      },
      "year": {
        "-1": "năm ngoái",
        "0": "năm nay",
        "1": "năm sau",
        "future": {
          "other": "sau {0} năm nữa"
        },
        "past": {
          "other": "{0} năm trước"
        }
      },
      "year-narrow": {
        "-1": "năm ngoái",
        "0": "năm nay",
        "1": "năm sau",
        "future": {
          "other": "sau {0} năm nữa"
        },
        "past": {
          "other": "{0} năm trước"
        }
      },
      "year-short": {
        "-1": "năm ngoái",
        "0": "năm nay",
        "1": "năm sau",
        "future": {
          "other": "sau {0} năm nữa"
        },
        "past": {
          "other": "{0} năm trước"
        }
      }
    },
    "locale": "vi"
  });
}